import styled, { css } from 'styled-components';
import { colors } from '../../../variables/colors.js';
import { fonts } from '../../../variables/fonts.js';
import { deviceWidths } from '../../../variables/widths.js';

var Title = styled.div.withConfig({
  displayName: "header__Title",
  componentId: "sc-f13y2w-0"
})(["flex-grow:1;font-family:", ";font-size:24px;h1,h2,h3,h4{font-family:", ";font-size:24px;}"], fonts.bold, fonts.bold);
var Header = styled.div.withConfig({
  displayName: "header__Header",
  componentId: "sc-f13y2w-1"
})(["align-items:center;background:", ";border-bottom:", " solid 1px;display:flex;justify-content:space-between;min-height:72px;padding:16px 0 16px 16px;position:sticky;top:0;z-index:1;", " @media (min-width:", "){border-bottom:0;padding:24px 0 0 32px;position:static;}.sg-popup-cancel-icon{align-self:flex-start;box-sizing:border-box;cursor:pointer;fill:", ";margin:10px 30px 0 30px;min-width:18px;width:18px;height:18px;@media (min-width:", "){margin:15px 30px 0 30px;}@media (min-width:", "){", "}}"], colors.white, colors.lightGray, function (props) {
  return props.roundedTop && css(["border-top-left-radius:30px;border-top-right-radius:30px;"]);
}, deviceWidths.tablet, colors.darkGray, deviceWidths.tablet, deviceWidths.desktopMax, function (props) {
  return props.tablet && css(["display:none;"]);
});

export { Header, Title };
//# sourceMappingURL=header.js.map
